module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/sports_coaching-ffec6d251c98f454bd482b19370b5279.png";